<header class="header">
	<div class="flexhead">
		<div class="flexcenter spaceleft">
			<div class="header-logo">
				<a routerLink="/slides/home" [defTrackEvent]="{ category: gaCategory, action: 'Navigate to Home' }">
					<img alt="Decathlon Exchange logo" src="assets/images/logo.png" width="103px" height="38px">
				</a>
			</div>
			<div class="header-countries">
				<def-locale-selector></def-locale-selector>
			</div>
		</div>

		<div class="flexcenter">
			<div class="header-tabs">
				<ul class="header-tabs--list flexcenter">
					<li>
						<a routerLink="formations">
							<def-menu-tabs class="header-tabs--list-tab"
														 [title]="'HEADER.FORMATION' | translate | uppercase" selectedTab="formations"
														 [defTrackEvent]="{ category: gaCategory, action: 'Navigate to Course Catalog' }"
														 [active]="currentUrl === 'formations'"></def-menu-tabs>
						</a>
					</li>
					<li>
						<a routerLink="reservations">
							<def-menu-tabs class="header-tabs--list-tab"
														 *nbIsGranted="['view', 'booking']"
														 [title]="'HEADER.RESERVE'| translate | uppercase" selectedTab="reservations"
														 [defTrackEvent]="{ category: gaCategory, action: 'Navigate to Room Booking' }"
														 [active]="currentUrl === 'reservations'"></def-menu-tabs>
						</a>
					</li>
				</ul>
			</div>
			<div class="header-buttons">
				<ul class="flexcenter">
					<li class="header-buttons--list">
						<a [defTrackEvent]="{ category: gaCategory, action: 'Go on Youtube Channel' }"
							 [href]="youtubeLink"
							 target="_blank" rel="noopener noreferrer"
							 class="header-buttons--list-rounded" mat-flat-button>
							<def-sprites class="sprite-center" sprite="social-youtube"
													 width="24px" height="24px" color="red">
							</def-sprites>
						</a>
					</li>
					<li class="header-buttons--list-button">
					</li>
				</ul>
			</div>
			<div class="header-tabs">
				<ul class="header-tabs--list flexcenter">
					<li>
						<def-header-choices class="header-tabs--list-tab"
																[choices]="ourContentMenuItems"
																[title]="'HEADER.OURCONTENT.TITLE'| translate | uppercase"
																[defTrackEvent]="{ category: gaCategory, action: 'Navigate to FAQ' }"
																borderSide="left"></def-header-choices>
					</li>
				</ul>
			</div>
		</div>

		<div class="flexcenter spaceright">
			<def-menu-burger [defTrackEvent]="{ category: gaCategory, action:'Open Menu Burger' }"
											 style="position: relative; left: 35px;"></def-menu-burger>
			<def-profile-sheet [defTrackEvent]="{ category: gaCategory, action:'Open Profil Sheet' }"></def-profile-sheet>
		</div>
	</div>
</header>
<def-loader [active]="loading"></def-loader>
